<nb-card>
  <nb-card-header>
    <span i18n="@@AdditionalDocuments">Документы</span>
    <button i18n-nbTooltip="@@Upload" (click)="showUploadForm = !showUploadForm" nbTooltip="Загрузить" nbButton status="control" size="small">
      <nb-icon icon="{{showUploadForm ? 'minus-outline' : 'plus-outline'}}"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <app-uploader *ngIf="showUploadForm" (upload)="onUpload($event)"/>

    <nb-list
      *ngIf="model?.documents?.length"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      [cdkDropListData]="model.documents">

      <nb-list-item
        *ngFor="let document of model.documents"
        cdkDrag
        cdkDragLockAxis="y">

        <div class="pointer" (click)="download(document)">{{ document.header }}</div>

        <div class="float-end">
          <button type="button" size="small" status="control">
            <nb-icon
              i18n-nbTooltip="@@Delete"
              (click)="removeDialog(document)"
              nbTooltip="Удалить"
              icon="close-outline"/>
          </button>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
</nb-card>
